import { __assign, __rest } from "tslib";
import React, { cloneElement, memo, useEffect, useRef, } from 'react';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
var additionalClassNames = function (componentData) {
    var classNameFromProps = '';
    if (componentData && componentData.props && componentData.props.data) {
        classNameFromProps = componentData.props.data.className;
        return twMerge('text-body', classNameFromProps);
    }
    return {};
};
export var VirtualRowMenuList = memo(function (_a) {
    var _b;
    var index = _a.index, setSize = _a.setSize, windowWidth = _a.windowWidth, data = _a.data;
    var rowRef = useRef(null);
    useEffect(function () {
        var _a;
        var rowRefHeight = (_a = rowRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
        if (rowRefHeight) {
            setSize(index, rowRefHeight);
        }
    }, [setSize, index, windowWidth]);
    return (React.createElement("div", { ref: rowRef }, cloneElement(data[index], __assign(__assign({}, data[index].props), { className: twMerge(cx((_b = data[index]) === null || _b === void 0 ? void 0 : _b.props.className, additionalClassNames(data[index]))) }))));
}, function (prevProps, nextProps) {
    var prevChildren = prevProps.children, restPrevProps = __rest(prevProps, ["children"]);
    var nextChildren = nextProps.children, restNextProps = __rest(nextProps, ["children"]);
    try {
        return (JSON.stringify(restPrevProps) === JSON.stringify(restNextProps));
    }
    catch (e) {
        return false;
    }
});
